import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKrediKartiList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKrediKartiList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetCreditCard: any[];
  GetCreditCard_dummy: any[];
  GetCreditCardChar: any[];
  GetCreditCardChar_dummy: any[];
  GetCreditCardTotal: any[];
  GetCreditCardTotal_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class KrediKartiList_ScreenBase extends React.PureComponent<
  IKrediKartiList_ScreenProps,
  any
> {
  kredikartilist_281550_value_kuikaSelectBoxRef: React.RefObject<any>;
  kredikartilist_262014_value_kuikaTableRef: React.RefObject<any>;
  kredikartilist_584872_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "73d05930-8e32-4dce-b1f3-26596b4ac129",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 253288, PropertyName: "label", Value: "Profil" },
        { Id: 767684, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 354121, PropertyName: "value", Value: "Kredi Kartları" },
        { Id: 588216, PropertyName: "value", Value: "Varlıklarım / Borçlarım" },
        { Id: 450762, PropertyName: "value", Value: "Toplam Tutar" },
        { Id: 542451, PropertyName: "placeholder", Value: "Banka Adı..." },
        { Id: 281550, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 31976, PropertyName: "label", Value: "Ara" },
        { Id: 950435, PropertyName: "label", Value: "Temizle" },
        {
          Id: 262014,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 111435, PropertyName: "title", Value: "Title" },
        { Id: 427654, PropertyName: "value", Value: "Mağaza Adı" },
        {
          Id: 286234,
          PropertyName: "value",
          Value: "[datafield:storedescription]",
        },
        { Id: 383434, PropertyName: "value", Value: "Mağaza Kodu" },
        { Id: 145635, PropertyName: "value", Value: "[datafield:storecode]" },
        { Id: 249253, PropertyName: "value", Value: "Banka Adı" },
        {
          Id: 419795,
          PropertyName: "value",
          Value: "[datafield:bankdescription]",
        },
        { Id: 25169, PropertyName: "value", Value: "Kart Tipi" },
        {
          Id: 398272,
          PropertyName: "value",
          Value: "[datafield:creditcardtypecode]",
        },
        { Id: 669125, PropertyName: "value", Value: "Tutar" },
        { Id: 196044, PropertyName: "value", Value: "[datafield:payment]" },
        { Id: 915751, PropertyName: "value", Value: "Para Birimi" },
        {
          Id: 442797,
          PropertyName: "value",
          Value: "[datafield:doccurrencycode]",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.kredikartilist_542451_value_kuikaTextInputRef = React.createRef();
    this.kredikartilist_281550_value_kuikaSelectBoxRef = React.createRef();
    this.kredikartilist_262014_value_kuikaTableRef = React.createRef();
    this.kredikartilist_584872_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetCreditCard: [],
      GetCreditCardChar: [],
      GetCreditCardTotal: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_281550: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kredikartilist", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.KrediKartiListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("kredikartilist", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kredikartilist", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.KrediKartiListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      kredikartilist_361434_value:
        this.state.GetImage?.at?.(0)?.photo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  KrediKartiListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      bankDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(3, "number"),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KrediKartiList/KrediKartiListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCreditCard = result?.data.getCreditCard;

    stateVars.GetCreditCardChar = result?.data.getCreditCardChar;

    stateVars.GetCreditCardTotal = result?.data.getCreditCardTotal;
    formVars.kredikartilist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCreditCardTotal !== undefined
        ? stateVars.GetCreditCardTotal?.length > 0
          ? stateVars.GetCreditCardTotal[0].tutar
          : null
        : this.state.GetCreditCardTotal?.length > 0
        ? this.state.GetCreditCardTotal[0].tutar
        : null
    );
    stateVars.GetImage = result?.data.getImage;
    formVars.kredikartilist_361434_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KrediKartiListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KrediKartiListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.kredikartilist_361434_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    stateVars.dataSource_452107 =
      stateVars.GetCreditCardChar ?? this.state.GetCreditCardChar;
    formVars.kredikartilist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCreditCardTotal !== undefined
        ? stateVars.GetCreditCardTotal?.length > 0
          ? stateVars.GetCreditCardTotal[0].tutar
          : null
        : this.state.GetCreditCardTotal?.length > 0
        ? this.state.GetCreditCardTotal[0].tutar
        : null
    );

    stateVars.dataSource_262014 =
      stateVars.GetCreditCard ?? this.state.GetCreditCard;
    formVars.kredikartilist_584872_total = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].totalCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].totalCount
        : null
    );
    formVars.kredikartilist_584872_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].pageCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].pageCount
        : null
    );

    formVars.kredikartilist_584872_total = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].totalCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].totalCount
        : null
    );
    formVars.kredikartilist_584872_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].pageCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  KrediKartiListComponent_961468_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "KrediKartiList",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "688065",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KrediKartiListComponent_253288_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "KrediKartiList",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KrediKartiListComponent_767684_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KrediKartiListComponent_281550_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      bankDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "kredikartilist_281550_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "kredikartilist_281550_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "kredikartilist_281550_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KrediKartiList/KrediKartiListComponent_281550_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCreditCard = result?.data.getCreditCard;

    stateVars.GetCreditCardChar = result?.data.getCreditCardChar;

    stateVars.GetCreditCardTotal = result?.data.getCreditCardTotal;
    formVars.kredikartilist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCreditCardTotal !== undefined
        ? stateVars.GetCreditCardTotal?.length > 0
          ? stateVars.GetCreditCardTotal[0].tutar
          : null
        : this.state.GetCreditCardTotal?.length > 0
        ? this.state.GetCreditCardTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.KrediKartiListComponent_281550_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KrediKartiListComponent_281550_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kredikartilist_584872_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_452107 =
      stateVars.GetCreditCardChar ?? this.state.GetCreditCardChar;
    formVars.kredikartilist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCreditCardTotal !== undefined
        ? stateVars.GetCreditCardTotal?.length > 0
          ? stateVars.GetCreditCardTotal[0].tutar
          : null
        : this.state.GetCreditCardTotal?.length > 0
        ? this.state.GetCreditCardTotal[0].tutar
        : null
    );

    stateVars.dataSource_262014 =
      stateVars.GetCreditCard ?? this.state.GetCreditCard;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KrediKartiListComponent_31976_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      bankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kredikartilist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "kredikartilist_281550_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kredikartilist_584872_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KrediKartiList/KrediKartiListComponent_31976_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCreditCard = result?.data.getCreditCard;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KrediKartiListComponent_31976_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KrediKartiListComponent_31976_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_262014 =
      stateVars.GetCreditCard ?? this.state.GetCreditCard;
    formVars.kredikartilist_584872_total = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].totalCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].totalCount
        : null
    );
    formVars.kredikartilist_584872_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].pageCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].pageCount
        : null
    );

    formVars.kredikartilist_584872_total = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].totalCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].totalCount
        : null
    );
    formVars.kredikartilist_584872_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].pageCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KrediKartiListComponent_950435_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kredikartilist_542451_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kredikartilist_281550_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("3", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kredikartilist_584872_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KrediKartiListComponent_950435_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KrediKartiListComponent_950435_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      bankDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KrediKartiList/KrediKartiListComponent_950435_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCreditCard = result?.data.getCreditCard;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KrediKartiListComponent_950435_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KrediKartiListComponent_950435_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_262014 =
      stateVars.GetCreditCard ?? this.state.GetCreditCard;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KrediKartiListComponent_584872_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      bankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kredikartilist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "kredikartilist_281550_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kredikartilist_584872_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KrediKartiList/KrediKartiListComponent_584872_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCreditCard = result?.data.getCreditCard;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.KrediKartiListComponent_584872_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KrediKartiListComponent_584872_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_262014 =
      stateVars.GetCreditCard ?? this.state.GetCreditCard;
    formVars.kredikartilist_584872_total = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].totalCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].totalCount
        : null
    );
    formVars.kredikartilist_584872_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].pageCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].pageCount
        : null
    );

    formVars.kredikartilist_584872_total = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].totalCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].totalCount
        : null
    );
    formVars.kredikartilist_584872_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetCreditCard !== undefined
        ? stateVars.GetCreditCard?.length > 0
          ? stateVars.GetCreditCard[0].pageCount
          : null
        : this.state.GetCreditCard?.length > 0
        ? this.state.GetCreditCard[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [688065] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.KrediKartiListPageInit();
    }
  }
}
